import React from "react";
import { OpportunityStatusEnumType } from "../../../../api/enums";
import { ColoredTag, ColoredTagProps } from "../../ColoredTag";
import { OpportunityStatusTagProps } from "./OpportunityStatusTag.types";

const OpportunityStatusTag: React.FC<OpportunityStatusTagProps> = ({
  status,
  ...rest
}) => {
  let color: ColoredTagProps["color"] = undefined;

  switch (status) {
    case OpportunityStatusEnumType.Open:
      color = "opportunity.open";
      break;
    case OpportunityStatusEnumType.ComingSoon:
      color = "opportunity.soon";
      break;
    case OpportunityStatusEnumType.FullCycle:
      color = "opportunity.full";
      break;
    case OpportunityStatusEnumType.Funded:
      color = "opportunity.funded";
      break;
  }

  return (
    <ColoredTag
      borderRadius={2}
      bg={color + "bg"}
      color={color}
      display={"inline-flex"}
      {...rest}
    >
      {status}
    </ColoredTag>
  );
};

export default OpportunityStatusTag;
